import { render } from "./Fallback.vue?vue&type=template&id=51e3d362&scoped=true"
import script from "./Fallback.vue?vue&type=script&lang=js"
export * from "./Fallback.vue?vue&type=script&lang=js"

import "./Fallback.vue?vue&type=style&index=0&id=51e3d362&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-51e3d362"

export default script